module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 59300.e12e7ed2.png";